var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-img',{attrs:{"src":require('@/assets/FriendlyFireColored.png'),"width":"200px","alt":"Friendly Fire Logo"}}),_c('small',{staticClass:"white--text signature font-weight-bold"},[_vm._v("v"+_vm._s(_vm.appVersion)+" © "+_vm._s(new Date().getFullYear()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }